export * from './elements/eab-sgd-time-calendar.js';
export * from './mixins/full_calendar_mixin.js';
export * from './types/calendar.js';

export class SgdTime {
  readonly id = 'sgd/time/index';
  readonly crate = 'sgd/time';
  readonly ns = 'sgd';
}

export default new SgdTime();
